import { Form, Input, Select } from '@maxtropy/components';
import { Col, Row } from 'antd';
import LevelSelect from './LevelSelect';
import { AnalysisUnit } from '../../BindUnitModal';

interface EnergyFlowRowProps {
  index: number;
  isEdit: boolean;
  unitGroup: AnalysisUnit[];
  onLoadingChange?: (loading: boolean) => void;
}
const EnergyFlowRow = ({ index, isEdit, unitGroup, onLoadingChange }: EnergyFlowRowProps) => {
  const form = Form.useFormInstance();
  const watchGroup = Form.useWatch(`energyAnalysisGroup${index}`, form);

  return (
    <>
      <Col span={24} key={index} style={{ marginBottom: '24px' }}>
        <Row gutter={44}>
          <Col flex="0 0 345px">
            <Form.Item name={`energyAnalysisGroup${index}`} style={{ marginBottom: 0 }}>
              <Select
                disabled={!isEdit}
                placeholder="请选择"
                options={unitGroup.map(u => ({ label: u.name, value: u.id }))}
                allowClear={true}
              />
            </Form.Item>
          </Col>
          <Col flex="0 0 345px">
            <Form.Item
              name={`levelRange${index}`}
              style={{ marginBottom: 0 }}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value && value.fromLevel > value.toLevel) {
                      return Promise.reject(new Error('下级节点数需大于等于上级节点数'));
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <LevelSelect disabled={!isEdit} energyUnitGroupId={watchGroup} onLoadingChange={onLoadingChange} />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default EnergyFlowRow;
